import shopDetailRegister from './registerCertificate'
import shopDetailBusiness from './businessCertificate'
import shopDetailWine from './wineCertificate'
export default {
  shopDetailRegister, // 登记簿
  shopDetailBusiness, // 营业执照
  shopDetailWine // 酒精销售许可证
}
